import './Frimi.scss';
import frimi from '../../assets/frimi_logo.png';
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from 'formik';
import * as Yup from 'yup';
import { Button } from '../../core/Button/Button';
import { BsArrowRightShort } from 'react-icons/bs';
import { TransactionDetails } from '../../types/api.types';
import { useSelector } from 'react-redux';
import { frimiSubmitAPI } from '../../services/frimi.service';
import { getJsonHash } from '../../utils/hashing.utils';
import { useState } from 'react';
import { encryptMessage } from '../../utils/cardEncryption.util';
import { FrimiNotification } from './FrimiNotification/FrimiNotification';
import { oneticketValidateAPI } from '../../services/oneticket.service';
import { toast } from 'react-toastify';

interface FormValues {
  frimi_id: string;
}
export const Frimi = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isAccept, setIsAccepting] = useState(false);
  const paymentDetails: TransactionDetails = useSelector(
    (state: any) => state.payment
  );

  const initialValues: FormValues = {
    frimi_id: '',
  };
  const validationSchema = Yup.object().shape({
    frimi_id: Yup.string().required('Frimi ID is required'),
  });

  const onSubmit = async (
    values: FormValues,
    { setSubmitting }: FormikHelpers<FormValues>
  ) => {
    setIsLoading(true);

    // if (paymentDetails.request_type == "TICKETING") {
    let oneticketData = {
      onepay_transaction_id: paymentDetails.data.onepay_transaction_id,
    };

    const validate_response: any = await oneticketValidateAPI(oneticketData);
    if (validate_response.status !== 200) {
      toast.error('Sorry you took too long to submit card details.', {
        autoClose: 3000,
      });

      // Add a small delay before redirecting
      setTimeout(() => {
        window.location.href = paymentDetails?.data.app.redirection_url;
      }, 3000); // Adjust the delay as needed for your toast duration

      return;
    }
    // }

    let cust_token =
      'eyJ0eXAiOiJKVciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoxNTg4NiOjU5fQ.y55EIrcmcspt-tBUFd';
    let request = {
      onepay_transaction_id: paymentDetails.data.onepay_transaction_id,
      app_id: paymentDetails.data.app.app_id,
      phone_number: encryptMessage(values.frimi_id),
    };
    let hash_value = await getJsonHash(request);
    const frimi_response = await frimiSubmitAPI(
      request,
      cust_token,
      hash_value
    );
    if (frimi_response.status == 200) {
      setIsLoading(false);
      setIsAccepting(true);
    }
  };
  return (
    <div>
      {!isAccept && (
        <>
          <div className="d-flex justify-content-center">
            <img className="w-25" src={frimi} alt="frimi" />
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => (
              <Form>
                <div className="row ms-3 me-3 pt-3">
                  <label className="card-lbl ps-0">FriMi ID</label>
                  <Field
                    type="text"
                    name="frimi_id"
                    className="txt-field"
                    placeholder="Enter FriMi Number"
                  />
                  <ErrorMessage
                    className="error"
                    name="frimi_id"
                    component="div"
                  />
                </div>

                <div className="ps-3 pe-3 pt-3">
                  <Button
                    buttonText={paymentDetails.data.app.action_bt_text}
                    type="submit"
                    icon={<BsArrowRightShort />}
                    className="pay-btn"
                    style={{
                      backgroundColor:
                        paymentDetails.data.app.action_button_bt_color,
                    }}
                    isLoading={isLoading}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </>
      )}

      {isAccept && (
        <>
          {' '}
          <div className="pb-4 frimi-accept">
            Now Open FriMi <img className="notify-frimi" src={frimi} /> on your
            mobile.
          </div>
          <div className="ps-5 pe-5">
            <FrimiNotification />
          </div>
        </>
      )}
    </div>
  );
};
